import React, { ReactNode, useState } from "react";
import { PortalContentContext } from "../../../context/PortalContentContext";
import { Portal } from "../../Portal/Portal";

interface IProps {
    children: ReactNode
}

export function PortalContentContainer({children}: IProps) {
    const [content, setContent] = useState<undefined | {[key: string]: ReactNode | ReactNode[]}>();
    return (
        <PortalContentContext.Provider value={{content, setContent}}>
            {children}
            <Portal>
                {Object.values(content ?? {})?.map((item, index) => {
                    return <React.Fragment key={index}>{item}</React.Fragment>
                })}
            </Portal>
        </PortalContentContext.Provider>
    )
}
